module.exports = __webpack_public_path__ + "assets/082015dbeff3412899c5b6d6bd07b043.png";